import {   Component,
  EventEmitter,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewEncapsulation, } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from 'app/shared/constant/constants';
import { ToastrService } from 'ngx-toastr';
import { CardService } from 'app/modules/card/services/card.service';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { CryptoUtils } from 'app/shared/utility/crypto.utils';
import { RequestOrderFeedbackModel } from 'app/modules/order/models/order.model';
import { MasterDataService } from 'app/shared/services/master-data.service';
import { UpdateProfileService } from 'app/modules/update-profile/services/update-profile.service';
import { BankAccountService } from 'app/modules/bank-account/services/bank-account.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { RemittanceService } from 'app/modules/remittance/services/remittance.service';
import { GTMDataLayerService } from 'app/shared/services/gtmDataLayer.service';
import { OrderService } from 'app/modules/order/services/order.service';
import { PaymentMode } from 'app/shared/constant/payment-mode';


import { AddBankAccountRequest } from "app/modules/bank-account/models/bank-account.model";

import { RequestAadhaarEsignDetail, RequestAadhaarEsignDetailOrder } from "app/modules/remittance/models/cart.model";
import { EsignMode } from "app/shared/constant/esign-mode";
import { WsfxBankDetails } from "app/shared/constant/wsfx-bank-details";
import { NgSelectComponent } from "@ng-select/ng-select/lib/ng-select.component";
import Swal from "sweetalert2";
import moment from "moment";
import { InitiatePaymentforCartRequest, QuotationCurrenciesRequestModel } from 'app/modules/card/models/card.model';


@Component({
  selector: 'xplorer-payment-page',
  templateUrl: './xplorer-payment-page.component.html',
  styleUrls: ['./xplorer-payment-page.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class XplorerCardPaymentPageComponent implements OnInit {


  public cartCurrenciesList = new Array<QuotationCurrenciesRequestModel>();
  public cryptoUtils: CryptoUtils = new CryptoUtils();
  public cartType: string = "CARD_PURCHASE";

  public bankBranchName: any;
  public showLoader: boolean = false;

  public modalReference: any;
  public paymentInstruction: any;
  public paymentMode: any;

  public paymentMethodsList = [];
  public banksList = [];
  public payScript: string;
  public initiatePaymentforCartRequest = new InitiatePaymentforCartRequest();
  public selectedPayMode = "CARD";


  public bankAccountId: any;
  public isPartial = 'false';


  public showAddBankForm: boolean = false;
  public ALLOW_NEFT_PAYMENT = Constants.ALLOW_NEFT_PAYMENT;
  public ALLOW_UPI_PAYMENT = Constants.ALLOW_UPI_PAYMENT;
  public selectedPaymentType: any;


  public selectedOption: string;
  public bankAccountList: any;

  public redeemableCredits: any;
  public listOffers: any;
  public promoCode: any;
  public pointsToRedeem: any;
  public showESignIframe: boolean = false;
  public isUnizCard: boolean = false;
  public orderId: string = "";


  @Output() childCallbackSender = new EventEmitter<string>();
  @ViewChild("EditCardModal") EditCardModal: TemplateRef<any>;
  @ViewChild("AmountLimitModal") AmountLimitModal: TemplateRef<any>;
  @ViewChild("deleteConfirmationDailog")
  deleteConfirmationDailog: TemplateRef<any>;

  public creditPointApplied: boolean = false;
  public promoCodeApplied: boolean = false;


  public accountName = WsfxBankDetails.ACCOUNT_NAME;
  public bankName = WsfxBankDetails.BANK_NAME;
  public accountNo = WsfxBankDetails.ACCOUNT_NUMBER;
  public bankIFSC = WsfxBankDetails.BANK_IFSC;
  public bankBranch = WsfxBankDetails.BANK_BRANCH;
  public urlSafe: SafeResourceUrl;
  public addBankAccountRequest = new AddBankAccountRequest();
  public consumerId: any;
  public bankDropdownItemList: any;
  public selectedPaymentMode: any;

  public productEnum: any;


  public consumerDetail: any;
  public bankRelationshipList = Constants.payerList;
  public showCashRefundNote: boolean = false;
  public isPromoCodeAdded: boolean = false;
  @ViewChild("refPromoCodeList") refPromoCodeList: NgSelectComponent;
  public isBookAndPayTermsAndCond;
  public NBPaymentHtml: string = "";
  public NBPaymentInProcees: boolean = false;
  public paymentProcessInProgress: boolean = false;
  public isReloadCash: boolean = false;
  public isOnlyExplorerBuyCard: boolean = false;


  public isReviewSubmitClick: boolean = false;
  public requestOrderFeedbackModel: RequestOrderFeedbackModel = new RequestOrderFeedbackModel();  
  userReview = '';
  selectedRating = 0;  
  currentText = 'How was your experience?';
  currentImage = '/assets/images/ad1/experience.gif';
  secondaryText = '';

  @ViewChild("rateUsModal") rateUsModal: TemplateRef<any>;
  public referralCodeApplied: boolean = false;
  public referredStatus: any = false;
  public referralCode: any = "";


  public showNetBanking: boolean = true;
  public showNEFT: boolean = true;
  public partialPaymentAllowed: boolean = true;
  public xplorerCardQuote:any;  


    constructor(
    private router: Router,
    public masterDataService: MasterDataService,
    private modalService: NgbModal,
    public bankAccountService: BankAccountService,
    public updateProfileService: UpdateProfileService,
    public cardService: CardService,
    public sanitizer: DomSanitizer,
    private fb: FormBuilder,
    public toast: ToastrService,
    public route: ActivatedRoute,
    private remittanceService: RemittanceService,
    public gtmPushService: GTMDataLayerService,
    public orderService: OrderService,
    private _location: Location
    ) { }
  
    ngOnInit(): void {
      this.getBankList();
      this.getBankAccountList();
      let xplorerStatus = sessionStorage.getItem(ConstantsKey.IS_ONLY_XPLORER_PURCHASE);
      if(xplorerStatus) {
        if(xplorerStatus == "YES") {
          this.isOnlyExplorerBuyCard = true;
        }
      }

      this.paymentMode = 'UPI';

      let xplorerCardQuoteResp = localStorage.getItem(ConstantsKey.XPLORER_CARD_PURCHASE_QUOTE);
      if(xplorerCardQuoteResp) {
        this.xplorerCardQuote = JSON.parse(xplorerCardQuoteResp);
      }    
      console.log("xplorerCardQuote ------ ", this.xplorerCardQuote);
      this.consumerId = localStorage.getItem(ConstantsKey.CONSUMER_ID);

    }
  


  // getCurrencies(productIndex) {
  //   // this.showLoader = true;
  //   this.reqGetCurrencyMaster.cartType = this.stepperDataCardModel.cartType;
  //   if (this.productEnum == Constants.productsEnum[1]) {
  //     this.reqGetCurrencyMaster.issuer = 'CASH';
  //   } else {
  //     this.reqGetCurrencyMaster.issuer = this.stepperDataCardModel.quotationRequest.issuerCode;
  //   }
  //   this.reqGetCurrencyMaster.partnerId = Constants.partnerId;
  //   this.reqGetCurrencyMaster.product = Constants.productsEnum[productIndex];

  //   if(this.cartType == 'CARD_RELOAD') {
  //     this.reqGetCurrencyMaster.walletType = this.cardData?.walletType;
  //   }

  //   this.masterDataService
  //     .getCurrenciesList(this.reqGetCurrencyMaster)
  //     .subscribe((result) => {

  //       //SWITCH_CARD_CURRENCY_CONDITION
  //       if((this.reqGetCurrencyMaster.issuer == "WSFXSWITCHMCC" && this.cartType == 'CARD_RELOAD' && this.cardData?.walletType == 'SCC')) {
  //         let currencies:any = result.body;
  //         currencies = currencies.filter(obj => obj.currencyCode == 'USD');
  //         this.allCurrencies = currencies;
  //         this.currencyItems = currencies;
  //       } else {
  //         if(this.cardType == "globalPayCard" && productIndex == 0) {
  //           this.allCurrencies = this.usdCurrency;
  //           this.currencyItems = this.usdCurrency;
  //         } else {
  //           this.allCurrencies = result.body;
  //           this.currencyItems = result.body;
  //         }
  //       }
        
  //      /*  this.allCurrencies = result.body;
  //       this.currencyItems = result.body; */

  //         if (this.currencyItems.length==1) {
  //           this.currencyCode = 'USD';
  //         }


        
  //       //Constants.currenciesListGlobal=result.body;
  //     });
  // }


  step04Payment() {
    // if(this.isCheckedForDoument) {
    // if (!this.isCartEmpty) {
      var paymentMode = this.selectedPaymentMode;
      if (paymentMode) {
        if (
          paymentMode == "MANUAL" ||
          (paymentMode == "NB" && this.bankAccountId != null) || (this.paymentMode == "UPI" && this.bankAccountId)
        ) {
          this.showLoader = true;
          // this.refreshQuotationCount = this.refreshQuotationCount + 1;
          this.modalReference.close();

          this.remittanceService
            .cartPlaceOrder(this.bankAccountId, this.paymentMode)
            .subscribe(
              (respPayment) => {
                this.showLoader = false;

                var respPaymentBody = JSON.parse(
                  JSON.stringify(respPayment.body)
                );
                console.log(
                  "respPaymentBody cart place order >",
                  respPaymentBody
                );

                /* let gamoogaEventName = "";
            if(this.cartType == "CARD_PURCHASE") {
              gamoogaEventName = "web_buy_card_order_payment";
            } else if(this.cartType == "CARD_RELOAD") {
              gamoogaEventName = "web_reload_order_payment"
            } else if(this.cartType == "CASH_PURCHASE") {
              gamoogaEventName = "web_currency_buy_order_payment"
            }

            let eventObj = {
              'name': gamoogaEventName,
              'event': gamoogaEventName,
              "payment-mode": paymentMode,
              "number": this.consumerDetail.mobile
            };

            this.gamoogaEvent(eventObj);  */

                /* if (paymentMode == PaymentMode.NET_BANKING) {
                  sessionStorage.setItem('Navigate_Back_to_stepper_card', 'true');
                  this.getPaymentGatewayLink(respPaymentBody.orderId);
                } else */ 
                 if(paymentMode == PaymentMode.UPI || paymentMode == PaymentMode.NET_BANKING) {
                  this.getUPIPaymentLink(respPaymentBody.orderId)
                  sessionStorage.setItem('Navigate_Back_to_stepper_card', 'true');

                } else {
                  sessionStorage.setItem('Navigate_Back_to_stepper_card', 'true');
                  this.router.navigate([
                    "/payment-success",
                    respPaymentBody.orderId,
                  ]);
                }
              },
              (error) => {
                this.showLoader = false;

                if (error.error.message.includes("PaymentMode.undefined")) {
                  this.toast.error("Please select payment method.");
                } else {
                  this.toast.error(error.error.message);
                }
              }
            );
        } else {
          this.toast.error("Please select your bank account");
        }
      } else {
        this.toast.error("Please select your payment method.");
      }
    /* } else {
      this.toast.error(Constants.emptyCartMsg);
    } */
  /* } else {
    this.toast.error("You must confirm that you have all the listed documents before proceeding.");
  } */


  }

  getPaymentGatewayLink(orderId: string) {
    this.showLoader = true;
    // this.getSessionData();
    // this.isPartial = this.stepperDataCardModel.isPartial;
    this.remittanceService
      .getPaymentGatewayLink(orderId, this.isPartial, this.bankAccountId)
      .subscribe(
        (respPaymentLink) => {
          this.showLoader = false;
          var responsePaymentLinkBody = JSON.parse(
            JSON.stringify(respPaymentLink.body)
          );
          window.location.href = responsePaymentLinkBody.payment_link;
        },
        (error) => {
          this.showLoader = false;
          console.log("Error in generating payment link", error);
        }
      );
  }

  proceedForPayment() {
    // this.refreshQuotationCount = this.refreshQuotationCount + 1;

    // this.quotationSnapshotId = this.quotationResponse.quotationSnapshotId;
    // console.log("this.quotationResponse >>", this.quotationResponse);

    if (this.selectedPayMode == "NB") {
      this.initiatePaymentforCartRequest.amount =
      //   this.stepperDataCardModel.quotationResponse.totalBillableAmountString;
      // this.initiatePaymentforCartRequest.paymentMedium = "B2C_WEB";
      // this.initiatePaymentforCartRequest.payertype =
      //   this.cartItemsResponse.cartPayer.paidBy;


      this.initiatePaymentforCartRequest.agreement = "true";
      // this.cardService
      //   .initiatePaymentforCart(
      //     this.initiatePaymentforCartRequest,
      //     this.quotationSnapshotId
      //   )
      //   .subscribe((respPay) => {
      //     var jsonResult = JSON.parse(JSON.stringify(respPay.body));
      //     localStorage.setItem("OrderId", jsonResult.orderId);
      //     console.log(jsonResult.redirectUrl);
      //     this.initiatePG(jsonResult.redirectUrl);
      //   });
    } else if (this.selectedPayMode == "CARD") {
    //   this.initiatePaymentforCartRequest.amount =
    //     this.stepperDataCardModel.quotationResponse.totalBillableAmountString;
    //   this.initiatePaymentforCartRequest.paymentMedium = "B2C_WEB";
    //   this.initiatePaymentforCartRequest.paymentModeCategoryId =
    //     this.paymentMethodsList[0]["paymentModeCategories"][0]["id"];
    //   this.initiatePaymentforCartRequest.payertype =
    //     this.cartItemsResponse.cartPayer.paidBy;
    //   this.initiatePaymentforCartRequest.agreement = "true";
    //   // this.loading = true;
    //   this.cardService
    //     .initiatePaymentforCart(
    //       this.initiatePaymentforCartRequest,
    //       this.quotationSnapshotId
    //     )
    //     .subscribe((respPay) => {
    //       // this.loading = false;
    //       let jsonResult = JSON.parse(JSON.stringify(respPay.body));
    //       localStorage.setItem("OrderId", jsonResult.orderId);
    //       console.log(jsonResult.redirectUrl);
    //       this.initiatePG(jsonResult.redirectUrl);
    //     });
    // } else {
    //   this.toast.error("Please select the mode of payment.");
    // }
  }
  }

  initiatePG(pgURL) {
    const url = pgURL;
    this.cardService.makePGCall(url).subscribe(
      (respPgCall) => {},
      (error) => {
        //ERROR
      }
    );

    const payScript =
      "var form = document.getElementById('ts-app-payment-form-redirect');";
    this.payScript = payScript;
    const iframe = document.getElementById("pgContainer");
    const script = document.createElement("script");
    script.type = "text/javascript";
    localStorage.setItem("pgRedirect", "true");
    script.text = payScript;
    iframe.appendChild(script);
    console.log(payScript);
  }

  /// call this when mode is N
  getPaymentMode() {
    this.cardService.getPaymentMethods().subscribe((respPayMethods) => {
      let jsonResult = JSON.parse(JSON.stringify(respPayMethods.body));
      var netBankingPayMode = jsonResult.filter(
        (payment) => payment.paymentMode === "NB"
      );
      this.banksList = netBankingPayMode[0].paymentModeCategories;
      this.paymentMethodsList = jsonResult;
    });

    // if (payMode == "NB") {
    //   this.showListNatbaking = true;
    // } else {
    //   this.showListNatbaking = false;
    // }
  }




  cartInitiate(step) {
    this.showLoader = true;
    // this.callCartItem(step);

    // this.cardService.cartPrepare(this.cartType).subscribe(response => {
    //   this.callCartItem(step);
    // });
  }







  openModalForPaymentInfo(paymentInstructionModal, bookAndPayInstructionModal) {
    sessionStorage.setItem(ConstantsKey.IS_FROM_REMITTANCE_FLOW, "false");
    if (this.cartType == "CARD_PURCHASE" || this.cartType == "CASH_PURCHASE") {
      sessionStorage.setItem(ConstantsKey.IS_FROM_RELOAD, "false");
      sessionStorage.setItem(ConstantsKey.IS_FROM_BUYNEWCARD, "true");
    } else {
      sessionStorage.setItem(ConstantsKey.IS_FROM_RELOAD, "true");
      sessionStorage.setItem(ConstantsKey.IS_FROM_BUYNEWCARD, "false");
    }

    // this.getSessionData();
    // if () {
      if (this.bankAccountId) {
        if (this.selectedPaymentType != null) {
          
          
          


          if (this.paymentMode == PaymentMode?.NET_BANKING || this.paymentMode == PaymentMode?.UPI) {
            this.paymentInstruction = "";
            console.log("IS PARTIAL ------------------------------------------------------------- ",this.isPartial);
            if(this.isPartial == 'true') {
              this.modalReference = this.modalService.open(bookAndPayInstructionModal, { centered: true } );
            } else {
              this.modalReference = this.modalService.open(paymentInstructionModal, { centered: true } );
            }


            // this.stepperDataCardModel.cartType
            let  eventName = "forex-card-order";
            let evtObj = {
              "event": eventName,
              "mobile": "91"+this.consumerDetail.mobile,
            };

            this.gamoogaEvent(evtObj);          




            
           // this.callQuotation();
          } else if (this.paymentMode == PaymentMode?.NEFT_RTGS || this.paymentMode == PaymentMode?.TPV ) {
            this.paymentInstruction = "If you choose to proceed with this mode of payment, we request you to upload the payment proof under the Order Details section in My Orders for timely processing.\n";
            this.modalReference = this.modalService.open(paymentInstructionModal, { centered: true });

            let eventName = "forex-card-order";

            let evtObj = {
              "event": eventName,
              "mobile": this.consumerDetail.mobile,
            };

            this.gamoogaEvent(evtObj);          

           // this.callQuotation();
          } else {
            this.toast.error("Please select payment method !");
          }
        } else {
          this.toast.error("Please select payment type!");
        }
      } else {
        if (this.bankAccountList.length == 0) {
          this.toast.error("Kindly add a new Bank Account");
        } else {
          this.toast.error("Please select your bank account.");
        }
      }
    /* } else {
      this.toast.error("Please select payment method !");
    } */
  }

  getSelectedBankAccountID(id) {
    this.bankAccountId = id;
    // this.updateSessionData();
  }

  getSelectedPaymentMode(paymentModeValue) {
    this.selectedPaymentMode = paymentModeValue;
    this.paymentMode = paymentModeValue;
    sessionStorage.setItem(ConstantsKey.PAYMENT_METHOD, paymentModeValue);
    // this.updateSessionData();
  }

  getSelectedPaymentType(paymentType) {
    if (paymentType == false) {
      this.showNetBanking = true;
      this.showNEFT = true;
    } else {
      this.showNetBanking = true;
      this.showNEFT = false;
    }
    this.selectedPaymentType = paymentType;
    // this.updateSessionData();
  }



  getBankAccountList() {
    this.cardService.getBankAccountList().subscribe((resp) => {
      this.bankAccountList = resp.body;
      console.log("this.bankAccountList >>", this.bankAccountList);
    });
  }

  goToAddBankAccount() {
    this.router.navigate(["/add-bank-account"]);
  }

  parentCallbackForAddBankAccountForm($event) {
    if ($event == "ADD_BANK_ACCOUNT_ADDED") {
      this.showAddBankForm = false;
      this.getBankAccountList();
    }
  }

  setPaymentModeAsManual() {
    // this.stepperDataCardModel.isPartial = false;
    /* sessionStorage.setItem(
      ConstantsKey.SS_ACTIVE_ORDER_CARD,
      JSON.stringify(this.stepperDataCardModel)
    ) */;
    this.childCallbackSender.emit("REFRESH_DATA");
  }

  getRedeemableCredits() {
    this.remittanceService.getRedeemableCredits().subscribe(
      (resp) => {
        this.redeemableCredits = resp.body;
        console.log("this.redeemableCredits >>", this.redeemableCredits);
      },
      (error) => {
        console.log("Unable to get credit points!", error);
      }
    );
  }

  applyCreditPointToQuote() {
    if (this.pointsToRedeem) {
     if (
        this.pointsToRedeem > this.redeemableCredits?.availableCredit
      ) {
        this.toast.error(
          "You can redeem maximum upto " +
            this.redeemableCredits?.maximumRedeemableCredit +
            "points!"
        );
      } else {
        // this.callQuotation();
        // this.getSessionData();
        this.creditPointApplied = true;
        this.toast.success("Credit points applied");
      }
    } else {
      this.toast.error("Please enter redeemable points");
    }
  }

  async removeCreditPoint() {
    this.pointsToRedeem = null;
    // await this.callQuotation();
    // this.getSessionData();
    this.creditPointApplied = false;
    this.toast.success("Credit points removed");
  }

  getOffers() {
    this.listOffers = [];
    let listOfferLocal = [];
    this.remittanceService.getOffers().subscribe(
      (resp) => {
        var offerListAll = JSON.parse(JSON.stringify(resp.body));
        for (let singleOffer of offerListAll) {
          if (
            singleOffer.status == "ACTIVE" &&
            (singleOffer.scope == "PRIVATE" || singleOffer.scope == "PUBLIC")
          ) {
            listOfferLocal.push(singleOffer);
          }
        }
        this.listOffers = listOfferLocal;
        console.log("OFFERS >>", this.listOffers);
      },
      (error) => {
        this.toast.error(error.error.message);
      }
    );
  }

  async applyPromoCode() {
    if (this.promoCode) {
      this.isPromoCodeAdded = true;
      // await this.callQuotation()
        // .then((res) => {
        //   if (res == "success") {
        //     // this.getSessionData();
        //     this.toast.success("Promocode applied successfully!");
        //     this.promoCodeApplied = true;
        //   }
        // })
        // .catch((err) => {
        //   if (err == "fail") {
        //     this.refPromoCodeList.handleClearClick();
        //   }
        // });
    } else {
      this.toast.error("Please enter promocode!");
    }
  }

  async removePromoCode() {
    this.promoCode = null;
    // await this.callQuotation();
    // this.getSessionData();
    this.toast.success("Promocode removed successfully!");
    this.promoCodeApplied = false;
  }

  // async hitGetQuotationCall() {
  //   var quotationRequest = this.stepperDataCardModel.quotationRequest;
  //   quotationRequest.paymentSourceDetails = this.stepperDataCardModel?.step02Data?.paymentSourceDetails;
  //   quotationRequest.calculateTcs = this.isCalculateTCS;
  //   var respQuotation = await this.cardService.getQuotation(quotationRequest).toPromise();
  //   this.stepperDataCardModel.quotationResponse = respQuotation.body;
  //   this.stepperDataCardModel.quotationRequest = quotationRequest;
  //   sessionStorage.setItem(ConstantsKey.SS_ACTIVE_ORDER_CARD, JSON.stringify(this.stepperDataCardModel));
  //   console.log("Quotation called");
  // }

  onSubmit() {
    this.modalReference.close();
    this.router.navigate(["/card-payment-success"]);
  }



  getMenuItemFromConfig() {
    // let data = sessionStorage.getItem('CONFIG_DATA');
    // this.configData = JSON.parse(data);
    // console.log(JSON.stringify(this.configData));

    // this.configData = {
    //   remittanceFlowEnable: true,
    //   personalFlowEnable: true,
    //   cardFlowEnable: true,
    //   insuranceEnable: true,
    //   dashboardEnable: true,
    //   myAccountMenuEnable: true,
    //   myAccountSubMenuEnable: true,
    //   relationshipEnable: true,
    //   beneficiaryEnable: true,
    //   bankAccountEnable: true,
    //   ordersEnable: true,
    //   pendingOrdersEnable: true,
    //   rewardsEnable: true,
    //   offersEnable: true,
    //   branchNetworkEnable: true,
    //   currencyConverterEnable: true,
    //   resetPasswordEnable: true,
    //   ratesEnable: true,
    //   setRateAlertEnable: true,
    //   supportEnable: true,
    //   addressEnable: true,
    //   faqEnable: true,
    //   tutorialEnable: true,
    //   paymentModeNBEnable: true,
    //   paymentModeNEFTEnable: true,
    //   partialPaymentEnable: true,
    //   openGICAccountEnable: true,
    //   blockedAccountEnable: true,
    //   zolveCreditCardEnable: true,
    //   isicCardEnable: true,
    // };
    // if (!this.configData?.paymentModeNBEnable) {
    //   this.showNetBanking = false;
    // } else if (!this.configData?.paymentModeNEFTEnable) {
    //   this.showNEFT = false;
    // } else if (!this.configData?.partialPaymentEnable) {
    //   this.partialPaymentAllowed = false;
    // }
  }

  showAddBankAccForm() {
    this.showAddBankForm = true;
  }

  addBankAccount(data) {
    if (data === true) {
      this.showLoader = true;
      if (
        this.addBankAccountRequest.number ===
        this.addBankAccountRequest.confirmAccNo
      ) {
        this.addBankAccountRequest.consumerId = this.consumerId;
        this.addBankAccountRequest.default = true;
        this.addBankAccountRequest.type = "SAVINGS";
        this.addBankAccountRequest.isDefault = true;
        this.addBankAccountRequest.branch = this.bankBranchName;
        console.log(JSON.stringify(this.addBankAccountRequest));

        this.bankAccountService
          .addMyBankAccount(this.addBankAccountRequest)
          .subscribe(
            (resp) => {
              this.showLoader = false;
              this.toast.success(
                "Bank account added successfully",
                "Success !!"
              );
              this.modalReference.close();

              this.getBankAccountList();
            },
            (error) => {
              this.showLoader = false;
              console.log(error);
              this.toast.error(error.error.message);
            }
          );
      } else {
        this.showLoader = false;
        this.toast.error("Account no and confirm account no. must be same");
      }
    }
  }

  openModalForAddBankAccount(addBankModal) {
    this.addBankAccountRequest.branch = null;
    this.modalReference = this.modalService.open(addBankModal, {
      size: "lg",
      centered: true,
    });
  }

  getBankList() {
    var singleObject;
    var localBankDropdownItemList;
    this.bankAccountService.getPaymentModes().subscribe((res) => {
      localBankDropdownItemList = res.body;
      for (let i = 0; i < localBankDropdownItemList.length; i++) {
        singleObject = localBankDropdownItemList[i];
        if (singleObject.categoryName == "Net Banking") {
          this.bankDropdownItemList = singleObject.paymentModeCategories;
        }
      }
    });
  }

  alphaNumberOnly(e) {
    // Accept only alpha numerics, not special characters
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }
    e.preventDefault();
    return false;
  }

  keyPressNumbers(event) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  // onPaste(e) {
  //   e.preventDefault();
  //   return false;
  // }


  addNewCoupon = (offer) => {
    return { title: offer, promoCodeId: offer };
  };

  getReferredStatus() {
    this.remittanceService.getReferredStatus().subscribe(
      (resp) => {
        this.referredStatus = resp.body;
        console.log("REFERRAL CODE ===== ", this.referralCodeApplied);
      },
      (err) => {}
    );
  }

  applyReferralCode() {
    if (this.referralCode == "") {
      this.toast.error("Please enter Referrer Code!");
    } else {
      this.remittanceService
        .updateConsumerReferrer({}, this.referralCode)
        .subscribe(
          (resp) => {},
          (error) => {
            this.showLoader = false;
            if (error.status == 202) {
              let response = JSON.parse(
                this.cryptoUtils.resDecrypt(error.error.text)
              );
              this.toast.success(response);
              this.referralCodeApplied = true;
            } else {
              this.toast.error(error.error.message);
            }
          }
        );
    }
  }

  gamoogaEvent(obj) {
    this.gtmPushService.dataLayerPushData(obj);
  }

  proceedBookAndPayPopup(travelDocumentInstructionModal) {
     if(this.isBookAndPayTermsAndCond) {
      this.modalReference.close();
      this.modalReference = this.modalService.open(travelDocumentInstructionModal, { centered: true } );
     } else {
      this.toast.error("Kindly accept the Terms & conditions");
     }
  }


  getUPIPaymentLink(orderId: string) {
    this.showLoader = true;
    // this.getSessionData();
    let requestObj = {
      'paymentType': this.paymentMode,
      'orderId': orderId,
      'bankId': this.bankAccountId,
      'product': this.productEnum,
      'deviceType': 'WEB'
    };


      // let orderType = { "ORDER_TYPE" : "XPLORER_CARD", "ORDER_ID": orderId };
      // localStorage.setItem(ConstantsKey.CURRENT_ORDER_TYPE, JSON.stringify(orderType));    

      localStorage.setItem(ConstantsKey.IS_CARD_ORDER_DONE, "IN_PROCESS"); 

    this.orderService.getPayULink(orderId, requestObj, this.isPartial).subscribe(resp => {
      this.showLoader = false;

      let orderType = { "ORDER_TYPE" : "CARD", "ORDER_ID": orderId };
      localStorage.setItem(ConstantsKey.CURRENT_ORDER_TYPE, JSON.stringify(orderType));

      var respUPIPayLinkData = JSON.parse(JSON.stringify(resp.body));
      localStorage.setItem(ConstantsKey.IS_CARD_ORDER_DONE, "IN_PROCESS"); 
      

      if(respUPIPayLinkData.status == "SUCCESS") {
        // if(this.paymentMode == "NB") {
        //   this.NBPaymentHtml = respUPIPayLinkData.htmlCode;
        //   document.open();          
        //   document.write(this.NBPaymentHtml);
        //   document.close();
        // } else if(this.paymentMode == "UPI") {
        // }
        if(respUPIPayLinkData.redirectionURL) {
          window.location.href = respUPIPayLinkData.redirectionURL;
        } else {
          this.NBPaymentHtml = respUPIPayLinkData.htmlCode;
          document.open();          
          document.write(this.NBPaymentHtml);
          document.close();
        }
      } else if(respUPIPayLinkData.status == "ERROR") {
        let errMsg:string = respUPIPayLinkData.errorDescription;
        if(errMsg.includes("not support PayU")) {
          this.getPaymentGatewayLink(orderId);
        }
      }


    }, error => {
      this.showLoader = false;
      console.log("Error in generating payment link");
    });
  }    


  ngOnDestroy(): void {
  }

  rate(rating: number) {
    this.selectedRating = rating;

    if (rating <= 3) {
      this.currentImage = '/assets/images/ad1/hear-you.gif';
      this.currentText = 'We hear you';
      this.secondaryText = 'What could we have done better?';
    } else {
      this.currentImage = '/assets/images/ad1/Excellent.gif';
      this.currentText = 'Excellent!';
      this.secondaryText = 'We’d love to hear about your experience.';
    }
  }

  submitReview() {

    if(this.userReview != "") {
    this.requestOrderFeedbackModel.orderId = this.orderId;
    this.requestOrderFeedbackModel.overall = this.selectedRating.toString();
    this.requestOrderFeedbackModel.comment = this.userReview;
    this.orderService.postOrderRating(this.requestOrderFeedbackModel).subscribe((respOrderRating => {
        this.showLoader = false;
        this.modalReference.close();
        // this.router.navigate(['/sit-back-relax', this.orderId]);
    }), error => {
        this.showLoader = false;
        this.modalReference.close();
        this.toast.error(error.error.message);
        // this.router.navigate(['/sit-back-relax', this.orderId]);        
    });
    } else {
      this.isReviewSubmitClick = true;
    }
  }  

  goToSitBackAndRelaxPage() {
    this.modalReference.close();
    this.router.navigate(['/sit-back-relax', this.orderId]);    
  }

  goToPaymentURl(){

            let orderType = { "ORDER_TYPE": "XPLORER_CARD", "ORDER_ID": this.xplorerCardQuote.id };
          localStorage.setItem(ConstantsKey.CURRENT_ORDER_TYPE, JSON.stringify(orderType));


  }


  getPayULink() {
    let selectedPaymentType = this.paymentMode;

    let requestObj = {
      'paymentType': selectedPaymentType,
      'orderId': this.xplorerCardQuote.id,
      'product': 'XPLORER_CARD_KIT',
      'deviceType': 'WEB',
      'orderType': 'XPLORER_CARD_KIT'
    };

    // if (this.paymentMode == "UPI") {
    //   requestObj['bankId'] = this.bankAccountId;
    // }

    console.log("requestObj ---- ", requestObj);

    this.orderService.getPayUOtherLink(requestObj).subscribe(resp => {
      this.showLoader = false;
      var respUPIPayLinkData = JSON.parse(JSON.stringify(resp.body));
      localStorage.setItem(ConstantsKey.IS_XPLORER_ORDER_DONE, "IN_PROCESS");
      //window.location.href = respUPIPayLinkData.redirectionURL;


      let orderType = { "ORDER_TYPE" : "XPLORER_CARD", "ORDER_ID": this.xplorerCardQuote.id };
      localStorage.setItem(ConstantsKey.CURRENT_ORDER_TYPE, JSON.stringify(orderType));

      var respUPIPayLinkData = JSON.parse(JSON.stringify(resp.body));
      localStorage.setItem(ConstantsKey.IS_CARD_ORDER_DONE, "IN_PROCESS"); 

      if (respUPIPayLinkData.status == "SUCCESS") {
        if (respUPIPayLinkData.redirectionURL) {
          window.location.href = respUPIPayLinkData.redirectionURL;
        } else {
          this.NBPaymentHtml = respUPIPayLinkData.htmlCode;
          document.open();
          document.write(this.NBPaymentHtml);
          document.close();
        }
      }
    }, err => {
      // console.log("err callQuotation >", err);
      this.toast.error(err.error.message);
    });
  }

  goToBackXplorerCard() {
    this._location.back();
  }

}
